import { memo } from "react";
import { DialogBottomButtonContent } from "./DialogBottomButtonContent";
import { getFullStateName } from "@/helpers/getFullStateName";
import { useIsLocationAllowed } from "@/hooks/useIsLocationAllowed";
import { centsToPrettyDollars } from "@skillscratch/shared-util";
import { storeListings } from "@/helpers/storeListings";
import type { GameTheme } from "@skillscratch/shared-types";


export const NextGameDialogContent = memo(function NextGameDialogContent({
  onNextGameClick,
  onGoHomeClick,
  isTutorial,
  gameTheme,
}: {
  onNextGameClick(): void;
  onGoHomeClick(): void;
  isTutorial: boolean;
  gameTheme: GameTheme;
}) {
  const [isLocationAllowed] = useIsLocationAllowed();
  const listing = storeListings.find((storeListing) => storeListing.id === gameTheme.id);

  return (
    <div className="flex flex-col h-72 w-full">
      <h1 className="text-center text-4xl font-extrabold text-blue-dark mt-6 mb-0">
        Next card?
      </h1>
      <p className="text-center text-xl text-blue font-extrabold mb-3 mt-2">
        Can win up to {centsToPrettyDollars(listing?.prizeAmount ?? 0, 'full2')}
      </p>
      <div className="flex-grow flex items-center justify-center">
        <DialogBottomButtonContent
          onNextGameClick={onNextGameClick}
          onGoHomeClick={onGoHomeClick}
          isTutorial={isTutorial}
          middleText={getFullStateName(isLocationAllowed?.locationName ?? 'PA')}
        />
      </div>
    </div>
  );
});